import React from "react";
import Icon, { type IconProps } from "./icon";

export default function ArticlesIcon({ className, width = 34, height = 34 }: IconProps) {
  return (
    <Icon
      className={`dewey--search--icon--articles ${className ?? ""}`}
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <path
        d="M25 27H9C7.89543 27 7 26.1046 7 25V9C7 7.89543 7.89543 7 9 7H25C26.1045 7 27 7.89543 27 9V25C27 26.1046 26.1045 27 25 27Z"
        stroke="#282828"
        strokeLinecap="round"
      />
      <path
        d="M15.4 16H10.6C10.2686 16 10 15.7314 10 15.4V10.6C10 10.2686 10.2686 10 10.6 10H15.4C15.7314 10 16 10.2686 16 10.6V15.4C16 15.7314 15.7314 16 15.4 16Z"
        stroke="#282828"
        strokeLinecap="round"
      />
      <path
        d="M10 20H21"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M10 23H16"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </Icon>
  );
}
